import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { Action, createReducer, on } from '@ngrx/store'

import { RolePermissions } from './role-permissions'
import { rolePermissionsActions } from './role-permission.actions'

export const FEATURE_NAME = 'rolePermissions'

export interface RolePermissionsState extends EntityState<RolePermissions> {
  isLoading: boolean
  error: any
}
export function sortBy(a: RolePermissions, b: RolePermissions): number {
  return a.id < b.id ? -1 : 0
}

export function keyBy(entity: RolePermissions): any {
  return entity.id
}

export const adapter: EntityAdapter<RolePermissions> =
  createEntityAdapter<RolePermissions>({
    sortComparer: sortBy,
    selectId: keyBy
  })

export const initialState: RolePermissionsState = adapter.getInitialState({
  isLoading: false,
  error: null,
  selectedEmailLogIds: []
})

const reducer = createReducer(
  initialState,
  // standard resource actions
  on(
    rolePermissionsActions.fetchOneById,
    rolePermissionsActions.fetchMany,
    rolePermissionsActions.createOne,
    rolePermissionsActions.createMany,
    rolePermissionsActions.updateOneById,
    rolePermissionsActions.deleteOne,
    rolePermissionsActions.deleteMany,
    (state) => {
      return {
        ...state,
        isLoading: true
      }
    }
  ),
  on(rolePermissionsActions.upsertOne, (state, { entity }) => {
    return adapter.upsertOne(entity, { ...state, isLoading: false })
  }),
  on(rolePermissionsActions.upsertMany, (state, { entities }) => {
    return adapter.upsertMany(entities, { ...state, isLoading: false })
  }),
  on(rolePermissionsActions.removeOne, (state, { id }) => {
    return adapter.removeOne(id, { ...state, isLoading: false })
  }),
  on(rolePermissionsActions.removeMany, (state, { ids }) => {
    return adapter.removeMany(ids, { ...state, isLoading: false })
  }),
  on(rolePermissionsActions.setLoading, (state, { isLoading }) => ({
    ...state,
    isLoading
  })),
  on(rolePermissionsActions.resetState, (state) => ({
    ...initialState
  })),
  // special actions
  on(rolePermissionsActions.fetchManyPublic, (state) => ({
    ...state,
    isLoading: true
  }))
)

export function rolePermissionsReducer(
  state: RolePermissionsState | undefined,
  action: Action
): RolePermissionsState {
  return reducer(state, action)
}
